
import api from "../../../api/api";



const  serialize = (obj) =>{
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
}



const getPendingByType = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("/report/grievance/pending-by-type").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    message: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                message: "Something Went Wrog",
                error : error
            })
        })
    })
}

const getPendingByGroup = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("/report/grievance/pending-by-group").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    message: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                message: "Something Went Wrog",
                error : error
            })
        })
    })
}


const getGrievanceByType = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("/report/grievance/grievance-by-type?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    message: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                message: "Something Went Wrog",
                error : error
            })
        })
    })
}


const getGrievanceByGroup = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("/report/grievance/grievance-by-group?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    message: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                message: "Something Went Wrog",
                error : error
            })
        })
    })
}






const getSuperVisorPending = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("/report/grievance/my-pending").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    message: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                message: "Something Went Wrog",
                error : error
            })
        })
    })
}


const getSuperVisrorGrievance = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("/report/grievance/my-grievance?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    message: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                message: "Something Went Wrog",
                error : error
            })
        })
    })
}


const getMemberRepeatedGrievance = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("/report/grievance/member-repeated-grievance?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    message: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                message: "Something Went Wrog",
                error : error
            })
        })
    })
}



const reportsServices = {
    getPendingByType,
    getPendingByGroup,
    getGrievanceByType,
    getGrievanceByGroup,

    getSuperVisorPending,
    getSuperVisrorGrievance,

    getMemberRepeatedGrievance
}
export default reportsServices;